
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 6.6.0
 * Query Engine version: f676762280b54cd07c770017ed3711ddde35f37a
 */
Prisma.prismaVersion = {
  client: "6.6.0",
  engine: "f676762280b54cd07c770017ed3711ddde35f37a"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  externalWalletId: 'externalWalletId',
  email: 'email',
  username: 'username',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  dust: 'dust',
  spent: 'spent'
};

exports.Prisma.SerialScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  redeemedAt: 'redeemedAt',
  value: 'value',
  redeemed: 'redeemed',
  product: 'product',
  redeemedById: 'redeemedById'
};

exports.Prisma.EventScalarFieldEnum = {
  id: 'id',
  externalId: 'externalId',
  occurredAt: 'occurredAt',
  type: 'type',
  data: 'data',
  userId: 'userId'
};

exports.Prisma.UserBadgeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  name: 'name',
  userId: 'userId'
};

exports.Prisma.SetScalarFieldEnum = {
  id: 'id',
  code: 'code',
  status: 'status',
  releasedAt: 'releasedAt',
  name: 'name'
};

exports.Prisma.CardScalarFieldEnum = {
  id: 'id',
  slug: 'slug',
  name: 'name',
  hotscore: 'hotscore'
};

exports.Prisma.ReverseCardScalarFieldEnum = {
  id: 'id',
  slug: 'slug',
  name: 'name',
  cardId: 'cardId'
};

exports.Prisma.GuardianScalarFieldEnum = {
  id: 'id',
  type: 'type',
  rarity: 'rarity',
  category: 'category',
  rulesText: 'rulesText',
  cost: 'cost',
  attack: 'attack',
  defense: 'defense',
  life: 'life',
  waterThreshold: 'waterThreshold',
  earthThreshold: 'earthThreshold',
  fireThreshold: 'fireThreshold',
  airThreshold: 'airThreshold',
  cardId: 'cardId'
};

exports.Prisma.SubtypeScalarFieldEnum = {
  id: 'id',
  name: 'name'
};

exports.Prisma.ReverseGuardianScalarFieldEnum = {
  id: 'id',
  type: 'type',
  rarity: 'rarity',
  category: 'category',
  rulesText: 'rulesText',
  cost: 'cost',
  attack: 'attack',
  defense: 'defense',
  life: 'life',
  waterThreshold: 'waterThreshold',
  earthThreshold: 'earthThreshold',
  fireThreshold: 'fireThreshold',
  airThreshold: 'airThreshold',
  cardId: 'cardId'
};

exports.Prisma.SetCardScalarFieldEnum = {
  id: 'id',
  slug: 'slug',
  setId: 'setId',
  cardId: 'cardId'
};

exports.Prisma.ReverseSetCardScalarFieldEnum = {
  id: 'id',
  slug: 'slug',
  setId: 'setId',
  cardId: 'cardId',
  setCardId: 'setCardId'
};

exports.Prisma.MetaScalarFieldEnum = {
  id: 'id',
  type: 'type',
  rarity: 'rarity',
  category: 'category',
  rulesText: 'rulesText',
  cost: 'cost',
  attack: 'attack',
  defense: 'defense',
  life: 'life',
  waterThreshold: 'waterThreshold',
  earthThreshold: 'earthThreshold',
  fireThreshold: 'fireThreshold',
  airThreshold: 'airThreshold',
  setCardId: 'setCardId'
};

exports.Prisma.ReverseMetaScalarFieldEnum = {
  id: 'id',
  type: 'type',
  rarity: 'rarity',
  category: 'category',
  rulesText: 'rulesText',
  cost: 'cost',
  attack: 'attack',
  defense: 'defense',
  life: 'life',
  waterThreshold: 'waterThreshold',
  earthThreshold: 'earthThreshold',
  fireThreshold: 'fireThreshold',
  airThreshold: 'airThreshold',
  setCardId: 'setCardId'
};

exports.Prisma.VariantScalarFieldEnum = {
  id: 'id',
  slug: 'slug',
  src: 'src',
  finish: 'finish',
  product: 'product',
  cardId: 'cardId',
  setCardId: 'setCardId',
  artistId: 'artistId'
};

exports.Prisma.VMetaScalarFieldEnum = {
  id: 'id',
  flavorText: 'flavorText',
  typeText: 'typeText',
  variantId: 'variantId'
};

exports.Prisma.ReverseVMetaScalarFieldEnum = {
  id: 'id',
  flavorText: 'flavorText',
  typeText: 'typeText',
  variantId: 'variantId'
};

exports.Prisma.ArtistScalarFieldEnum = {
  id: 'id',
  slug: 'slug',
  name: 'name'
};

exports.Prisma.ReverseVariantScalarFieldEnum = {
  id: 'id',
  slug: 'slug',
  src: 'src',
  finish: 'finish',
  product: 'product',
  cardId: 'cardId',
  setCardId: 'setCardId',
  variantId: 'variantId',
  artistId: 'artistId'
};

exports.Prisma.ElementScalarFieldEnum = {
  id: 'id',
  name: 'name'
};

exports.Prisma.KeywordScalarFieldEnum = {
  id: 'id',
  name: 'name'
};

exports.Prisma.FaqScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  question: 'question',
  answer: 'answer',
  questionGrid: 'questionGrid',
  answerGrid: 'answerGrid',
  priority: 'priority',
  deleted: 'deleted',
  deletedAt: 'deletedAt'
};

exports.Prisma.FaqDiffScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.DeckScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  format: 'format',
  visibility: 'visibility',
  primer: 'primer',
  hotscore: 'hotscore',
  set: 'set',
  userId: 'userId',
  featureId: 'featureId',
  folderId: 'folderId'
};

exports.Prisma.DeckChangeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  board: 'board',
  quantity: 'quantity',
  deckId: 'deckId',
  cardId: 'cardId',
  variantId: 'variantId'
};

exports.Prisma.AvatarCardScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  quantity: 'quantity',
  deckId: 'deckId',
  cardId: 'cardId',
  variantId: 'variantId'
};

exports.Prisma.DeckCardScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  quantity: 'quantity',
  deckId: 'deckId',
  cardId: 'cardId',
  variantId: 'variantId'
};

exports.Prisma.SideboardCardScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  quantity: 'quantity',
  deckId: 'deckId',
  cardId: 'cardId',
  variantId: 'variantId'
};

exports.Prisma.MaybeboardCardScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  quantity: 'quantity',
  deckId: 'deckId',
  cardId: 'cardId',
  variantId: 'variantId'
};

exports.Prisma.DeckViewScalarFieldEnum = {
  id: 'id',
  viewedAt: 'viewedAt',
  deckId: 'deckId'
};

exports.Prisma.DeckLikeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  userId: 'userId',
  deckId: 'deckId'
};

exports.Prisma.DeckCommentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  content: 'content',
  deckId: 'deckId',
  commenterId: 'commenterId'
};

exports.Prisma.DeckStarScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  userId: 'userId',
  deckId: 'deckId'
};

exports.Prisma.FolderScalarFieldEnum = {
  id: 'id',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId'
};

exports.Prisma.CollectionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId'
};

exports.Prisma.CollectionChangeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  quantity: 'quantity',
  list: 'list',
  collectionId: 'collectionId',
  cardId: 'cardId',
  variantId: 'variantId'
};

exports.Prisma.CollectionItemScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  condition: 'condition',
  notes: 'notes',
  collectionId: 'collectionId',
  cardId: 'cardId',
  variantId: 'variantId'
};

exports.Prisma.StoreScalarFieldEnum = {
  id: 'id',
  externalId: 'externalId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  address: 'address',
  country: 'country',
  state: 'state',
  lat: 'lat',
  lng: 'lng',
  link: 'link',
  contact: 'contact',
  searchable: 'searchable',
  playerCount: 'playerCount',
  playStatus: 'playStatus',
  onlineRetailStatus: 'onlineRetailStatus',
  physicalRetailStatus: 'physicalRetailStatus'
};

exports.Prisma.LinkScalarFieldEnum = {
  id: 'id',
  distanceMetres: 'distanceMetres',
  distanceText: 'distanceText',
  travelDurationSeconds: 'travelDurationSeconds',
  travelDurationText: 'travelDurationText',
  storeAId: 'storeAId',
  storeBId: 'storeBId'
};

exports.Prisma.DistributorScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  region: 'region',
  link: 'link',
  logoSrc: 'logoSrc'
};

exports.Prisma.TournamentScalarFieldEnum = {
  id: 'id',
  externalId: 'externalId',
  updatedAt: 'updatedAt',
  createdAt: 'createdAt',
  startsAt: 'startsAt',
  playerCount: 'playerCount',
  name: 'name',
  status: 'status',
  tier: 'tier',
  storeId: 'storeId'
};

exports.Prisma.TournamentDeckScalarFieldEnum = {
  id: 'id',
  externalId: 'externalId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  placement: 'placement',
  format: 'format',
  visibility: 'visibility',
  userId: 'userId',
  featureId: 'featureId',
  deckId: 'deckId',
  tournamentId: 'tournamentId'
};

exports.Prisma.TournamentAvatarCardScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  quantity: 'quantity',
  cardId: 'cardId',
  variantId: 'variantId',
  tournamentDeckId: 'tournamentDeckId'
};

exports.Prisma.TournamentDeckCardScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  quantity: 'quantity',
  cardId: 'cardId',
  variantId: 'variantId',
  tournamentDeckId: 'tournamentDeckId'
};

exports.Prisma.TournamentSideboardCardScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  quantity: 'quantity',
  cardId: 'cardId',
  variantId: 'variantId',
  tournamentDeckId: 'tournamentDeckId'
};

exports.Prisma.TransactionScalarFieldEnum = {
  id: 'id',
  externalId: 'externalId',
  createdAt: 'createdAt',
  amount: 'amount',
  description: 'description',
  error: 'error',
  type: 'type',
  status: 'status',
  userId: 'userId',
  serialId: 'serialId',
  eventId: 'eventId',
  tournamentId: 'tournamentId'
};

exports.Prisma.CardeSyncScalarFieldEnum = {
  id: 'id',
  type: 'type',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  cursor: 'cursor'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.UserOrderByRelevanceFieldEnum = {
  id: 'id',
  externalWalletId: 'externalWalletId',
  email: 'email',
  username: 'username'
};

exports.Prisma.SerialOrderByRelevanceFieldEnum = {
  id: 'id',
  redeemedById: 'redeemedById'
};

exports.Prisma.EventOrderByRelevanceFieldEnum = {
  id: 'id',
  externalId: 'externalId',
  data: 'data',
  userId: 'userId'
};

exports.Prisma.UserBadgeOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId'
};

exports.Prisma.SetOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name'
};

exports.Prisma.CardOrderByRelevanceFieldEnum = {
  id: 'id',
  slug: 'slug',
  name: 'name'
};

exports.Prisma.ReverseCardOrderByRelevanceFieldEnum = {
  id: 'id',
  slug: 'slug',
  name: 'name',
  cardId: 'cardId'
};

exports.Prisma.GuardianOrderByRelevanceFieldEnum = {
  id: 'id',
  rulesText: 'rulesText',
  cardId: 'cardId'
};

exports.Prisma.SubtypeOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.ReverseGuardianOrderByRelevanceFieldEnum = {
  id: 'id',
  rulesText: 'rulesText',
  cardId: 'cardId'
};

exports.Prisma.SetCardOrderByRelevanceFieldEnum = {
  id: 'id',
  slug: 'slug',
  setId: 'setId',
  cardId: 'cardId'
};

exports.Prisma.ReverseSetCardOrderByRelevanceFieldEnum = {
  id: 'id',
  slug: 'slug',
  setId: 'setId',
  cardId: 'cardId',
  setCardId: 'setCardId'
};

exports.Prisma.MetaOrderByRelevanceFieldEnum = {
  id: 'id',
  rulesText: 'rulesText',
  setCardId: 'setCardId'
};

exports.Prisma.ReverseMetaOrderByRelevanceFieldEnum = {
  id: 'id',
  rulesText: 'rulesText',
  setCardId: 'setCardId'
};

exports.Prisma.VariantOrderByRelevanceFieldEnum = {
  id: 'id',
  slug: 'slug',
  src: 'src',
  cardId: 'cardId',
  setCardId: 'setCardId',
  artistId: 'artistId'
};

exports.Prisma.VMetaOrderByRelevanceFieldEnum = {
  id: 'id',
  flavorText: 'flavorText',
  typeText: 'typeText',
  variantId: 'variantId'
};

exports.Prisma.ReverseVMetaOrderByRelevanceFieldEnum = {
  id: 'id',
  flavorText: 'flavorText',
  typeText: 'typeText',
  variantId: 'variantId'
};

exports.Prisma.ArtistOrderByRelevanceFieldEnum = {
  id: 'id',
  slug: 'slug',
  name: 'name'
};

exports.Prisma.ReverseVariantOrderByRelevanceFieldEnum = {
  id: 'id',
  slug: 'slug',
  src: 'src',
  cardId: 'cardId',
  setCardId: 'setCardId',
  variantId: 'variantId',
  artistId: 'artistId'
};

exports.Prisma.ElementOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.KeywordOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.FaqOrderByRelevanceFieldEnum = {
  id: 'id',
  question: 'question',
  answer: 'answer',
  questionGrid: 'questionGrid',
  answerGrid: 'answerGrid'
};

exports.Prisma.FaqDiffOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.DeckOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  primer: 'primer',
  userId: 'userId',
  featureId: 'featureId',
  folderId: 'folderId'
};

exports.Prisma.DeckChangeOrderByRelevanceFieldEnum = {
  id: 'id',
  deckId: 'deckId',
  cardId: 'cardId',
  variantId: 'variantId'
};

exports.Prisma.AvatarCardOrderByRelevanceFieldEnum = {
  id: 'id',
  deckId: 'deckId',
  cardId: 'cardId',
  variantId: 'variantId'
};

exports.Prisma.DeckCardOrderByRelevanceFieldEnum = {
  id: 'id',
  deckId: 'deckId',
  cardId: 'cardId',
  variantId: 'variantId'
};

exports.Prisma.SideboardCardOrderByRelevanceFieldEnum = {
  id: 'id',
  deckId: 'deckId',
  cardId: 'cardId',
  variantId: 'variantId'
};

exports.Prisma.MaybeboardCardOrderByRelevanceFieldEnum = {
  id: 'id',
  deckId: 'deckId',
  cardId: 'cardId',
  variantId: 'variantId'
};

exports.Prisma.DeckViewOrderByRelevanceFieldEnum = {
  id: 'id',
  deckId: 'deckId'
};

exports.Prisma.DeckLikeOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  deckId: 'deckId'
};

exports.Prisma.DeckCommentOrderByRelevanceFieldEnum = {
  id: 'id',
  content: 'content',
  deckId: 'deckId',
  commenterId: 'commenterId'
};

exports.Prisma.DeckStarOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  deckId: 'deckId'
};

exports.Prisma.FolderOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  userId: 'userId'
};

exports.Prisma.CollectionOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId'
};

exports.Prisma.CollectionChangeOrderByRelevanceFieldEnum = {
  id: 'id',
  list: 'list',
  collectionId: 'collectionId',
  cardId: 'cardId',
  variantId: 'variantId'
};

exports.Prisma.CollectionItemOrderByRelevanceFieldEnum = {
  id: 'id',
  notes: 'notes',
  collectionId: 'collectionId',
  cardId: 'cardId',
  variantId: 'variantId'
};

exports.Prisma.StoreOrderByRelevanceFieldEnum = {
  id: 'id',
  externalId: 'externalId',
  name: 'name',
  address: 'address',
  country: 'country',
  state: 'state',
  link: 'link',
  contact: 'contact'
};

exports.Prisma.LinkOrderByRelevanceFieldEnum = {
  id: 'id',
  distanceText: 'distanceText',
  travelDurationText: 'travelDurationText',
  storeAId: 'storeAId',
  storeBId: 'storeBId'
};

exports.Prisma.DistributorOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  link: 'link',
  logoSrc: 'logoSrc'
};

exports.Prisma.TournamentOrderByRelevanceFieldEnum = {
  id: 'id',
  externalId: 'externalId',
  name: 'name',
  storeId: 'storeId'
};

exports.Prisma.TournamentDeckOrderByRelevanceFieldEnum = {
  id: 'id',
  externalId: 'externalId',
  name: 'name',
  userId: 'userId',
  featureId: 'featureId',
  deckId: 'deckId',
  tournamentId: 'tournamentId'
};

exports.Prisma.TournamentAvatarCardOrderByRelevanceFieldEnum = {
  id: 'id',
  cardId: 'cardId',
  variantId: 'variantId',
  tournamentDeckId: 'tournamentDeckId'
};

exports.Prisma.TournamentDeckCardOrderByRelevanceFieldEnum = {
  id: 'id',
  cardId: 'cardId',
  variantId: 'variantId',
  tournamentDeckId: 'tournamentDeckId'
};

exports.Prisma.TournamentSideboardCardOrderByRelevanceFieldEnum = {
  id: 'id',
  cardId: 'cardId',
  variantId: 'variantId',
  tournamentDeckId: 'tournamentDeckId'
};

exports.Prisma.TransactionOrderByRelevanceFieldEnum = {
  id: 'id',
  externalId: 'externalId',
  description: 'description',
  error: 'error',
  userId: 'userId',
  serialId: 'serialId',
  eventId: 'eventId',
  tournamentId: 'tournamentId'
};

exports.Prisma.CardeSyncOrderByRelevanceFieldEnum = {
  id: 'id'
};
exports.SerialProductEnum = exports.$Enums.SerialProductEnum = {
  Earlybird: 'Earlybird',
  Arthurian_Legends: 'Arthurian_Legends'
};

exports.EventTypeEnum = exports.$Enums.EventTypeEnum = {
  Achievement_Earned: 'Achievement_Earned',
  Box_Authenticated: 'Box_Authenticated',
  Admin_Dust_Granted: 'Admin_Dust_Granted',
  Admin_Achievement_Granted: 'Admin_Achievement_Granted'
};

exports.UserBadgeEnum = exports.$Enums.UserBadgeEnum = {
  Earlybird: 'Earlybird',
  Arthurian_Legends: 'Arthurian_Legends'
};

exports.SetCodeEnum = exports.$Enums.SetCodeEnum = {
  alp: 'alp',
  bet: 'bet',
  art: 'art'
};

exports.SetStatusEnum = exports.$Enums.SetStatusEnum = {
  Released: 'Released',
  Unreleased: 'Unreleased'
};

exports.CardTypeEnum = exports.$Enums.CardTypeEnum = {
  Avatar: 'Avatar',
  Minion: 'Minion',
  Magic: 'Magic',
  Aura: 'Aura',
  Artifact: 'Artifact',
  Site: 'Site',
  None: 'None'
};

exports.CardRarityEnum = exports.$Enums.CardRarityEnum = {
  Unique: 'Unique',
  Elite: 'Elite',
  Exceptional: 'Exceptional',
  Ordinary: 'Ordinary',
  None: 'None'
};

exports.CardCategoryEnum = exports.$Enums.CardCategoryEnum = {
  Avatar: 'Avatar',
  Spell: 'Spell',
  Site: 'Site',
  Token: 'Token',
  None: 'None'
};

exports.SubtypeEnum = exports.$Enums.SubtypeEnum = {
  Angel: 'Angel',
  Beast: 'Beast',
  Demon: 'Demon',
  Dragon: 'Dragon',
  Dwarf: 'Dwarf',
  Faerie: 'Faerie',
  Giant: 'Giant',
  Gnome: 'Gnome',
  Goblin: 'Goblin',
  Knight: 'Knight',
  Merfolk: 'Merfolk',
  Monster: 'Monster',
  Mortal: 'Mortal',
  Ogre: 'Ogre',
  Royalty: 'Royalty',
  Spirit: 'Spirit',
  Sphinx: 'Sphinx',
  Troll: 'Troll',
  Undead: 'Undead',
  Armor: 'Armor',
  Automaton: 'Automaton',
  Device: 'Device',
  Document: 'Document',
  Instruments: 'Instruments',
  Monument: 'Monument',
  Potion: 'Potion',
  Relic: 'Relic',
  Weapon: 'Weapon',
  Desert: 'Desert',
  River: 'River',
  Tower: 'Tower',
  Village: 'Village'
};

exports.VariantFinishEnum = exports.$Enums.VariantFinishEnum = {
  Standard: 'Standard',
  Foil: 'Foil'
};

exports.VariantProductEnum = exports.$Enums.VariantProductEnum = {
  Booster: 'Booster',
  Preconstructed_Deck: 'Preconstructed_Deck',
  Box_Topper: 'Box_Topper',
  Pledge_Pack: 'Pledge_Pack',
  Draft_Kit: 'Draft_Kit',
  Store_Kit: 'Store_Kit',
  Promo: 'Promo'
};

exports.ElementEnum = exports.$Enums.ElementEnum = {
  Earth: 'Earth',
  Fire: 'Fire',
  Water: 'Water',
  Air: 'Air',
  None: 'None'
};

exports.KeywordEnum = exports.$Enums.KeywordEnum = {
  Airborne: 'Airborne',
  Burrowing: 'Burrowing',
  Charge: 'Charge',
  Deathrite: 'Deathrite',
  Disabled: 'Disabled',
  Flood: 'Flood',
  Genesis: 'Genesis',
  Immobile: 'Immobile',
  Lance: 'Lance',
  Landbound: 'Landbound',
  Lethal: 'Lethal',
  Movement: 'Movement',
  Ranged: 'Ranged',
  Spellcaster: 'Spellcaster',
  Stealth: 'Stealth',
  Submerge: 'Submerge',
  Voidwalk: 'Voidwalk',
  Waterbound: 'Waterbound'
};

exports.DeckFormatEnum = exports.$Enums.DeckFormatEnum = {
  Constructed: 'Constructed',
  Multiplayer: 'Multiplayer',
  Draft: 'Draft',
  Sealed: 'Sealed'
};

exports.DeckVisibilityEnum = exports.$Enums.DeckVisibilityEnum = {
  Public: 'Public',
  Private: 'Private'
};

exports.TrackedDeckChangeBoardEnum = exports.$Enums.TrackedDeckChangeBoardEnum = {
  Avatar: 'Avatar',
  Main: 'Main'
};

exports.CollectionItemConditionEnum = exports.$Enums.CollectionItemConditionEnum = {
  M: 'M',
  NM: 'NM',
  SP: 'SP',
  MP: 'MP',
  HP: 'HP'
};

exports.StoreApplicationStatusEnum = exports.$Enums.StoreApplicationStatusEnum = {
  Draft: 'Draft',
  Pending: 'Pending',
  Approved: 'Approved',
  Denied: 'Denied',
  Optedout: 'Optedout',
  NA: 'NA'
};

exports.DistributorRegionEnum = exports.$Enums.DistributorRegionEnum = {
  USA: 'USA',
  Canada: 'Canada',
  UK: 'UK',
  Europe_And_UK: 'Europe_And_UK',
  Europe: 'Europe',
  Scandinavia_And_Baltics: 'Scandinavia_And_Baltics',
  Asia: 'Asia',
  Australia: 'Australia',
  New_Zealand: 'New_Zealand'
};

exports.TournamentStatusEnum = exports.$Enums.TournamentStatusEnum = {
  Canceled: 'Canceled',
  Pending: 'Pending',
  Running: 'Running',
  Complete: 'Complete'
};

exports.TournamentTierEnum = exports.$Enums.TournamentTierEnum = {
  Local: 'Local',
  Regional: 'Regional',
  National: 'National'
};

exports.TransactionTypeEnum = exports.$Enums.TransactionTypeEnum = {
  Order: 'Order',
  Tournament: 'Tournament',
  Admin: 'Admin',
  Code: 'Code'
};

exports.TransactionStatusEnum = exports.$Enums.TransactionStatusEnum = {
  Pending: 'Pending',
  Synced: 'Synced',
  Failed: 'Failed',
  Dead: 'Dead'
};

exports.CardeSyncTypeEnum = exports.$Enums.CardeSyncTypeEnum = {
  Store: 'Store',
  User: 'User',
  Activity: 'Activity',
  Transaction: 'Transaction'
};

exports.Prisma.ModelName = {
  User: 'User',
  Serial: 'Serial',
  Event: 'Event',
  UserBadge: 'UserBadge',
  Set: 'Set',
  Card: 'Card',
  ReverseCard: 'ReverseCard',
  Guardian: 'Guardian',
  Subtype: 'Subtype',
  ReverseGuardian: 'ReverseGuardian',
  SetCard: 'SetCard',
  ReverseSetCard: 'ReverseSetCard',
  Meta: 'Meta',
  ReverseMeta: 'ReverseMeta',
  Variant: 'Variant',
  VMeta: 'VMeta',
  ReverseVMeta: 'ReverseVMeta',
  Artist: 'Artist',
  ReverseVariant: 'ReverseVariant',
  Element: 'Element',
  Keyword: 'Keyword',
  Faq: 'Faq',
  FaqDiff: 'FaqDiff',
  Deck: 'Deck',
  DeckChange: 'DeckChange',
  AvatarCard: 'AvatarCard',
  DeckCard: 'DeckCard',
  SideboardCard: 'SideboardCard',
  MaybeboardCard: 'MaybeboardCard',
  DeckView: 'DeckView',
  DeckLike: 'DeckLike',
  DeckComment: 'DeckComment',
  DeckStar: 'DeckStar',
  Folder: 'Folder',
  Collection: 'Collection',
  CollectionChange: 'CollectionChange',
  CollectionItem: 'CollectionItem',
  Store: 'Store',
  Link: 'Link',
  Distributor: 'Distributor',
  Tournament: 'Tournament',
  TournamentDeck: 'TournamentDeck',
  TournamentAvatarCard: 'TournamentAvatarCard',
  TournamentDeckCard: 'TournamentDeckCard',
  TournamentSideboardCard: 'TournamentSideboardCard',
  Transaction: 'Transaction',
  CardeSync: 'CardeSync'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }

        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
